let serverHost = "https://gsmh.ducklabs.com.br";

if (process.env.NODE_ENV === "development") {
  serverHost = "http://localhost:8080";
}

export const serverUrl = (path: string) => {
  return `${serverHost}${path}`;
};
